import { Box } from "@mui/material";
import { DamContentGallery, ManualCropUsingCdn } from "@platformx/x-image-render";
import { memo, useRef, useState } from "react";
import { GalleryOption } from "./GalleryOption";

const XGalleryWithText = ({ callBack, items, setItems }) => {
  const [galleryDialogOpen, setGalleryDialogOpen] = useState(false);
  const [imageDialog, setImageDialog] = useState(false);
  const currentItem = useRef(0);
  const [manualCropShow, setManualCropShow] = useState(false);

  const handleSelectedVideo = (video) => {
    callBack(video, currentItem.current, "video");
    toggleVideoGallery(false);
  };

  const toggleVideoGallery = (toggleState: boolean) => {
    setGalleryDialogOpen(toggleState);
  };

  const toggleImageGallery = (toggleState: boolean) => {
    setImageDialog(toggleState);
  };

  const showGallery = (type, id) => {
    window.scrollTo(0, 0);
    currentItem.current = id;
    if (type === "images") setImageDialog(true);
    else setGalleryDialogOpen(true);
  };

  const handleSelectedImage = (selectedAsset) => {
    const payload = {
      original_image: selectedAsset || {},
      published_images: [],
    };

    toggleImageGallery(false);
    callBack(payload, currentItem.current);
  };

  const changeCrop = (id) => {
    currentItem.current = id;
    setManualCropShow(true);
  };

  const backTo = () => {
    if (manualCropShow) setManualCropShow(false);
  };

  const doneCropCompleted = (cropHints: any[] = []) => {
    if (cropHints.length > 0) {
      const currentSelectedItem = items.find((item) => item.id === currentItem.current);
      const data = {
        ...currentSelectedItem?.image,
        published_images: cropHints,
      };

      callBack(data, currentItem.current);
    }

    setManualCropShow(false);
  };

  const currentSelectedItem = items.find((item) => item.id === currentItem.current);

  return (
    <>
      <Box
        sx={{
          backgroundColor: "#FFF",
        }}>
        {imageDialog && (
          <DamContentGallery
            handleImageSelected={handleSelectedImage}
            toggleGallery={toggleImageGallery}
            assetType={"Image"}
            processing={false}
            dialogOpen={imageDialog}
            isCrop={true}
          />
        )}
        {galleryDialogOpen && (
          <DamContentGallery
            handleSelectedVideo={handleSelectedVideo}
            toggleGallery={toggleVideoGallery}
            assetType={"Video"}
            dialogOpen={galleryDialogOpen}
          />
        )}
      </Box>
      {manualCropShow && (
        <ManualCropUsingCdn
          open={manualCropShow}
          isCrop={true}
          backTo={backTo}
          doneCropCompleted={doneCropCompleted}
          originalImage={currentSelectedItem?.image?.original_image}
          published_images={currentSelectedItem?.image?.published_images}
        />
      )}
      <GalleryOption
        showGallery={showGallery}
        items={items}
        setItems={setItems}
        changeCrop={changeCrop}
      />
    </>
  );
};

export default memo(XGalleryWithText);
